import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_admin/_legacy/bulk-notification")({
  beforeLoad: () => {
    throw redirect({to: "/admins/bulk-notification", replace: true});
  },
});
